export const CustomerTypes = ['Billing', 'Freight', 'EDI', 'Collections'];

export const CarrierTypes = ['Billing', 'Driver', 'Dispatch'];
